"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITradeTrustTokenRestorable__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "restore",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}];

class ITradeTrustTokenRestorable__factory {
  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.ITradeTrustTokenRestorable__factory = ITradeTrustTokenRestorable__factory;

_defineProperty(ITradeTrustTokenRestorable__factory, "abi", _abi);